import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import useReductionsSection from "../../hooks/useReductionsSection";
import { useSettlementStore } from "../../store/settlementStore";
import { SETTLEMENT_STYLES } from "../../style/styles";
import SettlementActionButtons from "../common/SettlementActionButtons";
import SettlementDateField from "../common/SettlementDateField";
import SettlementTextField from "../common/SettlementTextField";

import ApprovalDateTooltip from "./ApprovalDateTooltip";

export default function ReductionsSection() {
  const caseDetail = useSettlementStore((state) => state.caseDetail);
  const {
    formValues,
    isDirty,
    isEditing,
    isEmailEditing,
    isSaving,
    canEditCaseSettlement,
    handleFieldChange,
    handleBeginEdit,
    handleBeginEmailEdit,
    handleClearEmail,
    handleCancel,
    handleSave,
  } = useReductionsSection({ caseDetail });

  return (
    <section
      className="flex min-h-[200px] flex-col rounded-[12px] p-4 shadow-sm"
      style={SETTLEMENT_STYLES.sectionCard}
    >
      <div className="flex items-center gap-3">
        <Svg
          name={SvgEnum.HisTrendingDown}
          color={SETTLEMENT_STYLES.sectionIconColor}
          sx={SETTLEMENT_STYLES.sectionIcon}
        />
        <h3 className="text-lg font-semibold" style={SETTLEMENT_STYLES.sectionTitle}>
          Reductions
        </h3>
      </div>

      <div className="mt-4 w-full">
        <SettlementTextField
          label="Received From"
          value={formValues.reductionReceivedFrom}
          onChange={(event) => handleFieldChange("reductionReceivedFrom", event.target.value)}
          placeholder="Enter email address"
          type="email"
          inputMode="email"
          isEditable={isEmailEditing}
          showEditIcon={canEditCaseSettlement && !isEmailEditing}
          showClearIcon={canEditCaseSettlement && isEmailEditing}
          onEditClick={handleBeginEmailEdit}
          onDisplayClick={handleBeginEmailEdit}
          onClear={handleClearEmail}
          canEdit={canEditCaseSettlement}
        />
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-3">
        <SettlementDateField
          label="Received Date"
          value={formValues.reductionReceivedDate}
          onOpen={handleBeginEdit}
          onFocus={handleBeginEdit}
          onChange={(newValue) => handleFieldChange("reductionReceivedDate", newValue)}
          disabled={!canEditCaseSettlement}
        />
        <SettlementDateField
          label="Approval Date"
          value={formValues.reductionApprovedDate}
          onOpen={handleBeginEdit}
          onFocus={handleBeginEdit}
          onChange={(newValue) => handleFieldChange("reductionApprovedDate", newValue)}
          labelAdornment={<ApprovalDateTooltip caseDetail={caseDetail} />}
          disabled={!canEditCaseSettlement}
        />
        <SettlementDateField
          label="Completion Date"
          value={formValues.reductionCompletedDate}
          onOpen={handleBeginEdit}
          onFocus={handleBeginEdit}
          onChange={(newValue) => handleFieldChange("reductionCompletedDate", newValue)}
          disabled={!canEditCaseSettlement}
        />
      </div>

      {isEditing && canEditCaseSettlement ? (
        <div className="mt-4 flex">
          <SettlementActionButtons
            disableSave={isSaving || !isDirty}
            handleOnClickSaveButton={handleSave}
            disableCancel={isSaving}
            handleOnClickCancelBtn={handleCancel}
          />
        </div>
      ) : null}
    </section>
  );
}
